import { Button, Tooltip } from 'antd';
import { MaterialFolder, OptionFolder } from 'api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SummerwoodSVG from './summerwoodsvg/summerwood-svg';

export interface TabPaneFilterProps {
  filters: Array<MaterialFolder> | Array<OptionFolder>;
  selectFilter: (f: MaterialFolder | OptionFolder | undefined) => void;
  selectedFilter: MaterialFolder | OptionFolder | undefined;
}

const TabPaneFilter: React.FunctionComponent<TabPaneFilterProps> = ({
  filters,
  selectFilter,
  selectedFilter,
}) => {
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div
          style={{
            display: 'flex',
            gridGap: '4px',
            maxWidth: '100%',
            flexWrap: 'wrap',
          }}
        >
          {filters.map((f :MaterialFolder | OptionFolder) => (
            <Button
              key={f.id}
              style={
                selectedFilter && f.id === selectedFilter.id
                  ? {
                      background: Theme['@primary-color'],
                      color: Theme['@white'],
                    }
                  : {
                      background: Theme['@grey-normal'],
                      color: Theme['@grey-dark'],
                      border: 'none',
                    }
              }
              onClick={() => {
                selectedFilter === f
                  ? selectFilter(undefined)
                  : selectFilter(f);
              }}
            >
              {f.title}
            </Button>
          ))}
        </div>
      </div>
    </>
  );
};

export default TabPaneFilter;
